document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".support-nav button");
  const contents = document.querySelectorAll(".faq-content");
  const questions = document.querySelectorAll(".faq-question");

  // Single "Expand All/Collapse All" button
  const expandCollapseButton = document.getElementById("expand-collapse-toggle");

  let clickedSearchItem = "";




  // Toggle function for expanding or collapsing all questions and nested FAQs
  function toggleExpandCollapse() {
    const isExpanded = expandCollapseButton.textContent === "Collapse All";

    if (isExpanded) {
      // Collapse all FAQ questions and nested FAQs
      questions.forEach((question) => {
        const answer = document.getElementById("faq-" + question.dataset.faq);
        const arrow = question.querySelector(".faq-arrow");
        if (question.classList.contains("activee")) {
          question.classList.remove("activee");
          answer.classList.add("hidden");
          arrow.innerHTML = '+';
          arrow.style.alignItems = "baseline";
        }
      });
      // Collapse nested FAQs
      document.querySelectorAll(".nested-faq-question").forEach((nestedFaq) => {
        const nestedAnswer = nestedFaq.nextElementSibling;
        const nestedArrow = nestedFaq.querySelector(".nested-faq-arrow");
        
        nestedFaq.classList.remove("activee");
        if (nestedAnswer) nestedAnswer.classList.add("hidden");
        if (nestedArrow) {
          nestedArrow.innerHTML = '+';
          nestedArrow.classList.remove('is-minus');
        }
      });
      // Update button text to "Expand All"
      expandCollapseButton.textContent = "Expand All";
    } else {
      // Expand all FAQ questions and nested FAQs
      questions.forEach((question) => {
        const answer = document.getElementById("faq-" + question.dataset.faq);
        const arrow = question.querySelector(".faq-arrow");
        if (!question.classList.contains("activee")) {
          question.classList.add("activee");
          answer.classList.remove("hidden");
          arrow.innerHTML = '-';
          arrow.style.alignItems = "center";
        }
      });
      // Expand nested FAQs
      document.querySelectorAll(".nested-faq-question").forEach((nestedFaq) => {
        const nestedAnswer = nestedFaq.nextElementSibling;
        const nestedArrow = nestedFaq.querySelector(".nested-faq-arrow");
        if (!nestedFaq.classList.contains("activee")) {
          nestedFaq.classList.add("activee");
          nestedAnswer.classList.remove("hidden");
          nestedArrow.innerHTML = '-';
          nestedArrow.classList.add('is-minus'); 
        }
      });
      // Update button text to "Collapse All"
      expandCollapseButton.textContent = "Collapse All";
    }
  }

  // Event listener for the "Expand/Collapse All" button
  if(expandCollapseButton) expandCollapseButton.addEventListener("click", toggleExpandCollapse);

  // Existing logic for question toggling
  let activeQuestion = null;
  questions.forEach((question) => {
    question.addEventListener("click", function () {
      const answer = document.getElementById("faq-" + this.dataset.faq);
      const arrow = this.querySelector(".faq-arrow");
      const isActive = this.classList.contains("activee");

      // Toggle active state
      this.classList.toggle("activee");
      if (isActive) {
        answer.classList.add("hidden");
        arrow.innerHTML = '+';
        arrow.style.alignItems = "baseline";
        arrow.classList.remove('is-minus'); 
      } else {
        answer.classList.remove("hidden");
        arrow.innerHTML = '-';
        arrow.style.alignItems = "center";
        arrow.classList.add('is-minus');
      }

      // Set the current question as active
      if (!isActive) {
        activeQuestion = this;
      } else {
        activeQuestion = null;
      }
       updateExpandCollapseButtonText();
    });
  });

  // Nested accordion logic
  const allNestedFaqs = document.querySelectorAll(".nested-faq-question");
  allNestedFaqs.forEach(function (nestedFaq) {
    nestedFaq.addEventListener("click", function () {
      const nestedAnswer = nestedFaq.nextElementSibling; // Select the next sibling directly
      const arrow = nestedFaq.querySelector(".nested-faq-arrow");
      if (nestedAnswer && nestedAnswer.classList.contains("hidden")) {
        nestedAnswer.classList.remove("hidden");
        arrow.innerHTML = '-';
        arrow.classList.add('is-minus'); // Add this
      } else if (nestedAnswer) {
        arrow.innerHTML = '+';
        nestedAnswer.classList.add("hidden");
        arrow.classList.remove('is-minus'); 
      }
    });
  });
  function hideAllQuestions(element) {
    element.querySelectorAll(".faq-question").forEach(function (question) {
      question.classList.remove("activee");
      question.querySelector(".faq-arrow").textContent = "+";
      question
        .closest(".faq-item")
        .querySelector(".faq-answer")
        .classList.add("hidden");
    });
  }
  // check any faq/nested open
  function updateExpandCollapseButtonText() {
  const anyFaqOpen = document.querySelector(".faq-question.activee, .nested-faq-question.activee");
  expandCollapseButton.textContent = anyFaqOpen ? "Collapse All" : "Expand All";
  }
  
});

 //mobile dropdown
document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.getElementById('dropdownToggle');
  const menu = document.getElementById('dropdownMenu');

  toggle.addEventListener('click', function () {
    menu.classList.toggle('hidden');
    toggle.classList.toggle('active');
  });

  // Optional: close on outside click
  document.addEventListener('click', function (e) {
    if (!toggle.contains(e.target) && !menu.contains(e.target)) {
      menu.classList.add('hidden');
      toggle.classList.remove('active');
    }
  });

  // Optional: handle in-page scroll to section for dynamic tab buttons
  menu.querySelectorAll('button[data-tab]').forEach(btn => {
    btn.addEventListener('click', () => {
      const tabId = btn.getAttribute('data-tab');
      const target = document.getElementById(tabId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
      menu.classList.add('hidden');
      toggle.classList.remove('active');
    });
  });
});

//chat button trigger

window.addEventListener("load", function () {
  const zenDeskTrigger = document.querySelector(".gorgias_trigger");
  if(zenDeskTrigger) {
    zenDeskTrigger.classList.remove("anchor-disabled");
    zenDeskTrigger.removeAttribute("aria-disabled");
    zenDeskTrigger.removeAttribute("tabindex");
    console.log("anchor-disabled class removed");
    zenDeskTrigger.addEventListener("click", function (e) {
      e.preventDefault();
      // The Zendesk snippet loads async, so retry briefly if it isn't ready yet
      if(openZendesk()) return;
      let tries = 0;
      let timer = setInterval(function () {
        tries++;
        if (openZendesk() || tries > 20) clearInterval(timer); // ~5s max
      }, 250);
    });
  }
});

function openZendesk() {
  if (typeof window.zE !== 'function') return false;
  try {
    // Messaging Web Widget (newer)
    window.zE('messenger', 'show');
    window.zE('messenger', 'open');
  }
  catch (e) {
    // Classic Web Widget fallback
    try {
      window.zE('webWidget', 'show');
      window.zE('webWidget', 'open');
    }
    catch (err) {
      return false;
    }
  }
  return true;
}

//hide expand/collpase
  function toggleExpandButtonVisibility() {
    const visibleContent = document.querySelector('.faq-content:not(.hidden)');
    const expandWrapper = document.getElementById('expand-collapse-wrapper');

    if (!visibleContent || !expandWrapper) return;

    const contentType = visibleContent.dataset.contentType;
    const excludedTypes = ['contact', 'terms', 'privacy'];

    if (excludedTypes.includes(contentType)) {
      expandWrapper.style.display = 'none';
    } else {
      expandWrapper.style.display = 'block';
    }
  }
  
document.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  const faqId = params.get("faq");

  if (!faqId) return;

  // Wait a bit in case content loads dynamically
  setTimeout(() => {
    // Try nested FAQ first
    let targetEl = document.querySelector(`.nested-faq-question[data-faq="${faqId}"]`);

    // Fallback to main FAQ
    if (!targetEl) {
      targetEl = document.querySelector(`.faq-question[data-faq="${faqId}"]`);
    }

    if (!targetEl) return;

    //  If nested, open parent first
    const parentQuestion = targetEl.closest(".faq-item")?.querySelector(".faq-question");
    if (parentQuestion && !parentQuestion.classList.contains("activee")) {
      parentQuestion.click();
    }

    //  Open target FAQ
    setTimeout(() => {
      if (!targetEl.classList.contains("activee")) {
        targetEl.click();
      }

      //  Scroll into view
      targetEl.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }, 150);
  }, 200);
});


  // Run on page load
  document.addEventListener('DOMContentLoaded', () => {
    toggleExpandButtonVisibility();

    // Update visibility when a tab is clicked
    document.querySelectorAll('[data-tab]').forEach(button => {
      button.addEventListener('click', () => {
        // Use a timeout if tab switch content is animated or delayed
        setTimeout(() => {
          toggleExpandButtonVisibility();
        }, 50);
      });
    });
  });



